/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CodeFrame
 */
export interface CodeFrame {
    /**
     * 
     * @type {string}
     * @memberof CodeFrame
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof CodeFrame
     */
    frameIndex: number;
    /**
     * 
     * @type {string}
     * @memberof CodeFrame
     */
    filename?: string;
    /**
     * 
     * @type {number}
     * @memberof CodeFrame
     */
    relativeLine?: number;
}

/**
 * Check if a given object implements the CodeFrame interface.
 */
export function instanceOfCodeFrame(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "frameIndex" in value;

    return isInstance;
}

export function CodeFrameFromJSON(json: any): CodeFrame {
    return CodeFrameFromJSONTyped(json, false);
}

export function CodeFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'frameIndex': json['frame_index'],
        'filename': !exists(json, 'filename') ? undefined : json['filename'],
        'relativeLine': !exists(json, 'relative_line') ? undefined : json['relative_line'],
    };
}

export function CodeFrameToJSON(value?: CodeFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'frame_index': value.frameIndex,
        'filename': value.filename,
        'relative_line': value.relativeLine,
    };
}

